import { Box, Text } from '@mantine/core';
import { formatUsDateTime } from '@/lib/dateHelpers';

export interface SignatureBlockValue {
  name?: string;
  license?: string;
  signedAt?: string;
  ipAddress?: string;
  signatureData?: string;
  signatureFormat?: string;
}

export interface SignatureBlockProps {
  label: string;
  signature?: SignatureBlockValue;
}

export function SignatureBlock({ label, signature }: SignatureBlockProps): JSX.Element {
  return (
    <Box
      p="md"
      style={{
        backgroundColor: 'var(--mantine-color-blue-0)',
        borderRadius: 'var(--mantine-radius-md)',
        minHeight: 160,
      }}
    >
      <Text size="sm" c="gray.6" mb={6}>
        {label}
      </Text>
      {signature ? (
        <>
          {signature.signatureData ? (
            <img
              src={`data:${signature.signatureFormat ?? 'image/png'};base64,${signature.signatureData}`}
              alt={signature.name ? `Signature of ${signature.name}` : 'Signature'}
              style={{ maxHeight: 60, maxWidth: '100%', objectFit: 'contain', display: 'block' }}
            />
          ) : signature.name ? (
            <Text
              size="xl"
              fw={600}
              c="gray.8"
              style={{ fontFamily: "'Brush Script MT', 'Segoe Script', 'Lucida Handwriting', cursive" }}
            >
              {signature.name}
            </Text>
          ) : null}
          {signature.license && (
            <Text size="md" c="gray.7" mt={6} style={{ whiteSpace: 'pre-line' }}>
              {signature.license}
            </Text>
          )}
          {signature.signedAt && (
            <Text size="sm" c="gray.6" mt={6}>
              {formatUsDateTime(signature.signedAt)}
            </Text>
          )}
          {signature.ipAddress && (
            <Text size="sm" c="gray.6" mt={6}>
              IP: {signature.ipAddress}
            </Text>
          )}
        </>
      ) : (
        <Text size="sm" c="gray.5" fs="italic">
          Not yet signed
        </Text>
      )}
    </Box>
  );
}
